import { render, staticRenderFns } from "./VolumePointDetail.vue?vue&type=template&id=0481698f"
import script from "./VolumePointDetail.vue?vue&type=script&lang=js"
export * from "./VolumePointDetail.vue?vue&type=script&lang=js"
import style0 from "./VolumePointDetail.vue?vue&type=style&index=0&id=0481698f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports